/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/

import PropTypes from "prop-types";
import React from "react";
import "./style.css";

export const BtnMenuHome = ({
  status,
  color,
  fluentHome = "/img/fluent-home-12-filled-1.svg",
}) => {
  return (
    <button className={`btn-menu-home status-0-${status}`}>
      {status === "on" && (
        <div className="group">
          <img className="fluent-home" alt="Fluent home" src={fluentHome} />
        </div>
      )}

      {status === "off" && (
        <svg
          width={27}
          height={27}
          viewBox="0 0 27 27"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M22.2855 4.5199L22.2946 4.51731C22.4489 4.47933 22.6107 4.48365 22.7628 4.52991C22.9182 4.57717 23.0576 4.66637 23.1656 4.78772C23.2736 4.90906 23.3461 5.05784 23.375 5.21769C23.404 5.37754 23.3883 5.54228 23.3296 5.69378L16.8296 22.4855C16.7772 22.6211 16.6921 22.7417 16.5819 22.8365C16.4717 22.9314 16.3398 22.9975 16.1979 23.0292C16.056 23.0608 15.9085 23.0569 15.7684 23.0178C15.6284 22.9788 15.5001 22.9058 15.3951 22.8053L11.7312 19.3007C11.6527 19.2255 11.5285 19.2269 11.4516 19.3037L10.1483 20.606C9.5852 21.1691 8.62208 20.7705 8.62208 19.9739V16.4119C8.62208 16.3573 8.59976 16.3051 8.56032 16.2673L2.93673 10.8886C2.82297 10.7797 2.74037 10.6425 2.69748 10.491C2.65458 10.3395 2.65296 10.1793 2.69277 10.027C2.73259 9.87462 2.8124 9.73569 2.92395 9.62457C3.03549 9.51344 3.1747 9.43414 3.32719 9.39489L22.2855 4.5199ZM19.9494 6.80578C20.0236 6.63781 19.6545 6.7261 19.6545 6.7261L5.65421 10.6195C5.58387 10.6376 5.52886 10.6924 5.5105 10.7626C5.49213 10.8329 5.51329 10.9076 5.56578 10.9578L9.56544 14.7819C9.63873 14.852 9.75286 14.8561 9.83103 14.7916L19.6756 7.07863C19.7327 7.04278 19.921 6.87001 19.9494 6.80578ZM20.7286 8.49644C20.7614 8.41159 21.0001 7.9565 20.9263 7.90328C20.8525 7.85005 20.5148 8.22556 20.4446 8.28351L11.1525 15.9933C11.1085 16.0297 11.0821 16.0832 11.08 16.1403C11.078 16.1973 11.1004 16.2526 11.1417 16.2921L15.3953 20.3545C15.4436 20.4007 15.5118 20.4197 15.5771 20.4052C15.6423 20.3907 15.696 20.3445 15.7201 20.2822L20.7286 8.49644Z"
            fill={color}
          />
        </svg>
      )}

      <div className="text-wrapper-6">Home</div>
    </button>
  );
};

BtnMenuHome.propTypes = {
  status: PropTypes.oneOf(["off", "on"]),
  fluentHome: PropTypes.string,
};
